import { Box, Grid, Tab, Tabs } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTableStyles } from "../../styles/useTableStyles";
import { CasterProcessData } from "./caster-process-data/CasterProcessData";
import { EAFProcessData } from "./eaf-process-data/EAFProcessData";
import { LabReport } from "./lab-report/LabReport";

export const HeatReportTabs: React.FC = () => {
	const classes = useTableStyles();
	const { asset } = useParams<{ asset: string }>();
	const navigate = useNavigate();
	const [value, setValue] = useState<string | false>(false);

	useEffect(() => {
		if (asset === "eaf") {
			setValue("eaf");
		} else if (asset === "caster") {
			setValue("caster");
		} else if (asset === "lab") {
			setValue("lab");
		} else {
			setValue("eaf");
			navigate("/heat-process-report/eaf", { replace: true });
		}
	}, [asset, navigate]);

	const handleChange = (_: React.ChangeEvent<{}>, newValue: string) => {
		setValue(newValue);
		navigate(`/heat-process-report/${newValue}`);
	};

	if (value === false) {
		return null;
	}

	return (
		<>
			<Tabs
				value={value}
				onChange={handleChange}
				classes={{
					root: classes.fileTabsRoot,
					indicator: classes.fileTabsIndicator,
				}}
			>
				<Tab
					label="EAF"
					value="eaf"
					classes={{
						root: classes.fileTabRoot,
						selected: classes.fileTabSelected,
					}}
				/>
				<Tab
					label="Caster"
					value="caster"
					classes={{
						root: classes.fileTabRoot,
						selected: classes.fileTabSelected,
					}}
				/>
				<Tab
					label="Lab"
					value="lab"
					classes={{
						root: classes.fileTabRoot,
						selected: classes.fileTabSelected,
					}}
				/>
			</Tabs>

			<Grid item xs={12} container spacing={1}>
				{asset === "eaf" && <EAFProcessData />}
				{asset === "caster" && <CasterProcessData />}
				{asset === "lab" && <LabReport />}
			</Grid>
		</>
	);
};
